export default {
    SET_NUMBERS_BLACKLIST(state, numbersBlacklist) {
        state.numbersBlacklist = numbersBlacklist
    },
    ADD_NUMBER_BLACKLIST(state, numberBlacklist) {
        state.numbersBlacklist.unshift(numberBlacklist)
    },
    UPDATE_NUMBER_BLACKLIST(state, numberBlacklist) {
        const numberBlacklistIndex = state.numbersBlacklist.findIndex((w) => w.id === numberBlacklist.id)
        Object.assign(state.numbersBlacklist[numberBlacklistIndex], numberBlacklist)
    },
    DELETE_NUMBER_BLACKLIST(state, numberBlacklistId) {
        const ItemIndex = state.numbersBlacklist.findIndex((w) => w.id === numberBlacklistId)
        state.numbersBlacklist.splice(ItemIndex, 1)
    },
    BLOCK_NUMBER_FROM_BLACKLIST(state, numberBlacklist) {
        const numberBlacklistIndex = state.numbersBlacklist.findIndex((w) => w.id === numberBlacklist.id)
        Object.assign(state.numbersBlacklist[numberBlacklistIndex], numberBlacklist)
    }
}
